import { ActionTypes } from "@/App/constants/actionTypes";
import { Action } from "@/App/actions";
import { GroupTypes } from "@/types";

export interface GroupGetState {
  group: {
    details: GroupTypes.Group;
  };
}

const DEFAULT_GROUP_GET_STATE: GroupGetState = {
  group: {
    details: {
      plan_account_id: null,
      id: null,
      group_name: "",
      effective_date: "",
      termination_date: "",
      coverage_strategy_id: "",
      coverage_effective_date: "",
      send_group_in_outbound_accumulator_data: null,
      accumulation_period_type: "",
      external_group_id: "",
      customer_service_phone_number: "",
      contract_number: "",
      plan_benefit_package_id: "",
      group_number: "",
    },
  },
};

export default (state: GroupGetState = DEFAULT_GROUP_GET_STATE, action: Action): {} => {
  if (action.type === ActionTypes.GET_GROUP_RESULTS) {
    return {
      ...state,
      group: {
        ...state.group,
        details: action.payload,
      },
    };
  } else if (action.type === ActionTypes.CLEAR_GROUP) {
    return DEFAULT_GROUP_GET_STATE;
  } else {
    return state;
  }
};
